import {Dispatchable} from "stem-core/src/base/Dispatcher";
import {authService} from "../../../../client/connection/Services";
import {AuthHelper} from "../../../AuthHelper";
import {isIframe} from "../../../Utils";
import {iFrameMerchantService} from "../../../services/IframeMerchantService";


class OAuth1Client extends Dispatchable {
    constructor(clientId, authServerUrl, loginEndpoint, requestTokenEndpoint) {
        super();

        this.authServerUrl = authServerUrl;
        this.requestTokenEndpoint = requestTokenEndpoint;
        this.loginEndpoint = loginEndpoint;
    }

    setLoginCallback(onLoginCallback) {
        this.onLoginCallback = () => onLoginCallback();
    }

    setLoginErrorCallback(onLoginErrorCallback) {
        this.onLoginErrorCallback = () => onLoginErrorCallback();
    }

    onRequestTokenCallback(response) {
        const urlParams = new URLSearchParams();
        urlParams.set("oauth_token", response.oauthToken);
        // If we're in an iframe, we send the referral merchant's ID in the OAuth state.
        if (isIframe()) {
            urlParams.set("state", JSON.stringify({merchantId: iFrameMerchantService.merchantId}));
        }

        const url = this.authServerUrl + "?" + urlParams.toString();

        AuthHelper.oauth1TokenReceivedCallback(url);
    }

    onRequestTokenErrorCallback() {}

    async login() {
        AuthHelper.oauth1Login();
        // Request a token from Blink API first
        try {
            const response = await authService.requestOAuthToken(this.requestTokenEndpoint);
            this.onRequestTokenCallback(response);
        } catch (error) {
            this.onRequestTokenErrorCallback(error);
        }
    }

    async handleLoginResponse(oauthToken, oauthVerifier) {
        try {
            await AuthHelper.oauthHandleLoginResponse(this.loginEndpoint, {
                oauthToken,
                oauthVerifier,
                termsAgreed: true,
            });
            this.onLoginCallback();
        } catch (error) {
            this.onLoginErrorCallback();
        }
    }
}

export {OAuth1Client};
